// Показателите на „Променени цени".
//
// БЕЗ Δ чипове: справката не пита предходния период. „С 12 % повече сменени
// цени от вчера" не отговаря на нищо, което този екран задава — тук се гледа
// колко е отнето и колко е добавено в САМИЯ период.
//
// Числата следват показаните редове (търсачка + филтри в колоните), както
// таблицата, редът „Общо" и Excel. Иначе един екран показва два обхвата:
// стесняваш до един сервитьор, а кутийката горе продължава да сумира всичко.
//
// Водещи са ДВЕТЕ суми — колко е отнето и колко е добавено; броят промени
// само ги обяснява и затова стои в равен ред до тях, без `hero`.

import { useTranslation } from "react-i18next";

import { fmtEuro } from "../../../../utils/currency";
import { ReportKpiCard } from "../ReportKpiCard";
import { pluralLabel } from "../reportPlural";
import type { PriceChangesSummary } from "./priceChangesMath";

/** Минус знак U+2212 — намалената цена е отнета сума. */
const MINUS = "−";

type Props = {
  summary: PriceChangesSummary;
  isNarrow: boolean;
};

export const PriceChangesKpis = ({ summary, isNarrow }: Props) => {
  const { t } = useTranslation();

  const rowsLabel = (count: number) =>
    pluralLabel(
      t,
      count,
      "reportsPage.priceChangesResultOne",
      "reportsPage.priceChangesResults",
    );

  return (
    // Класовете са ЦЕЛИ литерали: Tailwind сканира изходния текст и не вижда
    // име, сглобено с template literal.
    <div
      className={`grid gap-2.5 ${
        isNarrow ? "grid-cols-2" : "grid-cols-2 lg:grid-cols-[1fr_1.2fr_1.2fr]"
      }`}
    >
      <ReportKpiCard
        kicker={t("reportsPage.priceChangesCountKicker")}
        value={String(summary.changes)}
        sub={t("reportsPage.priceChangesCountTitle")}
      />

      <ReportKpiCard
        kicker={t("reportsPage.priceChangesDownTitle")}
        value={
          summary.downTotal > 0
            ? `${MINUS}${fmtEuro(summary.downTotal)}`
            : fmtEuro(0)
        }
        sub={rowsLabel(summary.downRows)}
        hot={summary.downTotal > 0}
        hero
      />

      <ReportKpiCard
        kicker={t("reportsPage.priceChangesUpTitle")}
        value={
          summary.upTotal > 0 ? `+${fmtEuro(summary.upTotal)}` : fmtEuro(0)
        }
        sub={rowsLabel(summary.upRows)}
        hero
      />
    </div>
  );
};
